import { CheckAvailabilityPage } from "./CheckAvailabilityPage";

export default CheckAvailabilityPage;
